export const getSubcategories = ({
  subCategoryReducer: { subcategories = [] } = {},
}) => subcategories;
export const getSubategoriesCount = ({
  subCategoryReducer: { count = 0 } = {},
}) => count;
export const getSubcategoriesFilter = ({
  subCategoryReducer: { filter = {} } = {},
}) => filter;
